<template>
  <v-form v-model="valid" ref="form" lazy-validation>
    <v-list subheader three-line>
      <v-subheader>Dormant Settings</v-subheader>

      <v-layout>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-text-field
                v-model="data.dormant_fee"
                label="Dormant Fee"
                class="inputNumOnly"
                prepend-icon="money"
                prefix="₱"
                placeholder="0"
                type="number"
                outline
              ></v-text-field>
            </v-list-tile-action>
          </v-list-tile>
        </v-flex>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-text-field
                v-model="data.dormant_duration"
                label="Dormant Duration"
                suffix="month"
                mask="####"
                outline
                required
                :rules="[rules.required, rules.number, rules.notZero]"
              ></v-text-field>
            </v-list-tile-action>
          </v-list-tile>
        </v-flex>
      </v-layout>
    </v-list>

    <v-divider></v-divider>
    <br />

    <v-list subheader three-line>
      <v-subheader>Device Printing Setup</v-subheader>

      <v-layout>
        <v-flex md4>
          <v-list-tile>
            <!-- <v-list-tile-action> -->
            <v-switch
              color="primary"
              v-model="data.load_print_status"
              :label="data.load_print_status ? `In-house` : `Merchant`"
            ></v-switch>
            <!-- </v-list-tile-action> -->
          </v-list-tile>
        </v-flex>
      </v-layout>
    </v-list>

    <v-divider></v-divider>
    <br />

    <div
      style=" display: flex;
    flex-direction: row;"
    >
      <v-card
        elevation="10"
        outlined
        style="margin:0px 0px 0px 70px; padding:15px 20px 30px 20px;"
      >
        <h3>Denomination List</h3>
        <v-divider></v-divider>

        <br v-if="data.denomination_list.length === 0" />
        <em
          v-if="data.denomination_list.length === 0"
          style="margin-left: 20px;font-size:18px; color: #ED5634;"
          >No data</em
        >
        <v-list-tile-action>
          <!-- <v-flex md4> -->
          <table>
            <v-layout v-for="(item, i) in data.denomination_list" :key="i">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-checkbox
                    style="margin: 0px 70px 0px 0px;"
                    v-model="item.status"
                    :label="$amountInPeso(item.value)"
                    color="#FFBE3D"
                    v-bind="attrs"
                    v-on="on"
                  ></v-checkbox>
                </template>
                <span v-if="!item.status"><strong>Enable</strong></span>
                <span v-if="item.status"><strong>Disable</strong></span>
              </v-tooltip>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    style="vertical-align: baseline; "
                    icon
                    @click="removeDenomination(item.value)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="red darken-4" dark center
                      >remove_circle</v-icon
                    >
                  </v-btn>
                </template>
                <span><strong>Remove</strong></span>
              </v-tooltip>
            </v-layout>
          </table>
          <!-- </v-flex> -->
        </v-list-tile-action>
      </v-card>
      <v-container>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="newDenomValue"
              style="width:30%; margin:0px 0px 0px 75px; position: static;"
              label="Input denomination"
              prefix="P"
              outline
              mask="#####"
              maxLength=5
              @keypress.enter="addDenomination()"
              :append-outer-icon="'mdi-plus-circle'"
              @click:append-outer="addDenomination()"
              v-bind="attrs"
              v-on="on"
            >
            </v-text-field>
          </template>
          <span
            >Press <u>Enter</u> key or click<br />the
            <strong>(+)</strong> button to add
            <strong>Denomination</strong></span
          >
        </v-tooltip>
        <!-- <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :style="{position: 'stricky', transform: 'translateX(400%) translateY(-80%)' }"
              color="#E7E5DF"
              fab
              small
              @click="addDenomination()"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dense large>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Add denomination</span>
        </v-tooltip> -->
      </v-container>
    </div>
    <br />
    <v-divider></v-divider>
      <br />

      <div 
        style="display: flex; 
        flex-direction: row;"
      >
        <v-card
          elevation="10"
          outlined
          style="margin:0px 0px 0px 70px; padding:15px 20px 30px 20px;"
        >
          <h3>Card Replacement Price List</h3>
          <v-divider></v-divider>

          <br v-if="data.card_replacement_price_list.length === 0" />
          <em
            v-if="data.card_replacement_price_list.length === 0"
            style="margin-left: 20px;font-size:18px; color: #ED5634;"
            >No data</em
          >
          <v-list-tile-action>
            <!-- <v-flex md4> -->
            <table>
              <v-layout v-for="(item, i) in data.card_replacement_price_list" :key="i">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-checkbox
                      style="margin: 0px 70px 0px 0px;"
                      v-model="item.status"
                      :label="$amountInPeso(item.value)"
                      :disabled="item.value == 150"
                      color="#FFBE3D"
                      v-bind="attrs"
                      v-on="on"
                    ></v-checkbox>
                  </template>
                  <span v-if="!item.status"><strong>Enable</strong></span>
                  <span v-if="item.status"><strong>Disable</strong></span>
                </v-tooltip>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      style="vertical-align: baseline; "
                      icon
                      @click="removeCardReplacementPrice(item.value)"
                      :disabled="item.value == 150"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="red darken-4" dark center
                        >remove_circle</v-icon
                      >
                    </v-btn>
                  </template>
                  <span><strong>Remove</strong></span>
                </v-tooltip>
              </v-layout>
            </table>
            <!-- </v-flex> -->
          </v-list-tile-action>
        </v-card>
        <v-container>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="newCardRepPrice"
                style="width:30%; margin:0px 0px 0px 75px; position: static;"
                label="Input Card Replacement Price"
                prefix="P"
                outline 
                mask="#####"
                maxLenght=5
                @keypress.enter="addCardReplacementPrice()"
                :append-outer-icon="'mdi-plus-circle'"
                @click:append-outer="addCardReplacementPrice()"
                v-bind="attrs"
                v-on="on"
              >
              </v-text-field>
            </template>
            <span
              >Press <u>Enter</u> key or click<br />the
              <strong>(+)</strong> button to add
              <strong>Card Replacement Price</strong></span
            >
          </v-tooltip>
          <!-- <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :style="{position: 'stricky', transform: 'translateX(400%) translateY(-80%)' }"
              color="#E7E5DF"
              fab
              small
              @click="addDenomination()"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dense large>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Add denomination</span>
        </v-tooltip> -->
        </v-container>
      </div>
      <br />
    <v-divider></v-divider>
    <v-list subheader three-line>
      <v-subheader>Device Lock Timer</v-subheader>
      <v-layout class="d-flex flex-row mb-6" style="width: 600px">
        <v-text-field
          v-model="computedData.sync_day"
          label="Days"
          outline
          class="inputNumOnly pa-2"
          placeholder="31"
          type="text"
          :rules="[
            rules.required,
            rules.number,
            rules.minDay,
            rules.maxDay,
            rules.requiredFormat,
          ]"
        ></v-text-field>

        <v-text-field
          v-model="computedData.sync_hour"
          label="Hours"
          outline
          class="inputNumOnly pa-2"
          placeholder="23"
          type="text"
          :rules="[
            rules.required,
            rules.number,
            rules.minFloor,
            rules.maxFloor,
            rules.requiredFormat,
          ]"
        ></v-text-field>

        <v-text-field
          v-model="computedData.sync_minute"
          label="Minutes"
          outline
          class="inputNumOnly pa-2"
          placeholder="59"
          type="text"
          :rules="[
            rules.required,
            rules.number,
            rules.minMinute,
            rules.maxMinute,
            rules.requiredFormat,
          ]"
        ></v-text-field>
      </v-layout>
    </v-list>
    <br />
    <v-divider></v-divider>
    <v-list subheader three-line>
      <v-subheader>Device Command Source</v-subheader>
      <v-layout>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-text-field
                v-model="data.command_source"
                label="Mobile Number"
                outline
                class="inputNumOnly"
                placeholder="+639175002342"
                type="text"
                prepend-icon="phone"
                :rules="[rules.required, rules.number, rules.notZero]"
              ></v-text-field>
            </v-list-tile-action>
          </v-list-tile>
        </v-flex>
      </v-layout>
    </v-list>

    <v-divider></v-divider>
    <v-list subheader three-line>
      <v-subheader>Transfer Module</v-subheader>
      <v-layout>
        <v-flex md4>
          <v-layout class="d-flex flex-row mb-6" style="width: 200px">
            <!-- <v-text-field
              v-model="computedData.transfer_fee_amount"
              label="Transfer Fee Amount"
              outline
              class="inputNumOnly pa-2"
              type="number"
              :rules="[rules.number]"
            ></v-text-field> -->

            <v-text-field
              v-model="computedData.transfer_fee_amount"
              label="Transfer Fee Amount"
              outline
              class="inputNumOnly pa-2"
              type="text"
              :rules="[rules.required, rules.number]"
            ></v-text-field>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-list>
  </v-form>
</template>

<script>
export default {
  props: {
    data: Object,
    subcompanies: Array,
  },
  computed: {
    computedData() {
      return {
        id: this.data.id,
        dormant_fee: this.data.dormant_fee ? this.data.dormant_fee : 0,
        dormant_duration: this.data.dormant_duration
          ? this.data.dormant_duration
          : 0,
        denomination_list: this.data.denomination_list,
        card_replacement_price_list: this.data.card_replacement_price_list,
        load_print_status: this.data.load_print_status,
        command_source: this.data.command_source,
        sync_day: this.data.sync_deadline.substr(0, 2),
        sync_hour: this.data.sync_deadline.substr(3, 2),
        sync_minute: this.data.sync_deadline.substr(6, 2),
        transfer_fee_amount: this.data.transfer_fee_amount,
      };
    },
    tripmanifest() {
      if (
        this.data.trip_manifest_status === 1 ||
        this.data.trip_manifest_status === true
      ) {
        return true;
      } else {
        return false;
      }
    },
    dispatcherStatus: {
      get() {
        return this.data.dispatcher_status;
      },
      set(value) {
        this.data.dispatcher_status = value;

        this.data.teller_status = 0;
      },
    },
    tellerStatus: {
      get() {
        return this.data.teller_status;
      },
      set(value) {
        this.data.teller_status = value;

        this.data.dispatcher_status = 0;
        this.data.conductor_status = 0;
      },
    },
  },
  data() {
    return {
      newDenomValue: null,
      valid: false,
      rules: {
        required: (value) => !!value || "This field is required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        number: (value) => !isNaN(value) || "Must be number.",
        notZero: (value) => value >= 1 || "This field is required.",
        minFloor: (value) => value >= 0 || "The minimum number is 0.",
        maxFloor: (value) => value <= 23 || "The maximum number is 23.",
        minDay: (value) => value >= 0 || "The minimum number is 0.",
        maxDay: (value) => value <= 31 || "The maximum number is 31.",
        minMinute: (value) => value >= 0 || "The minimum number is 0.",
        maxMinute: (value) => value <= 59 || "The maximum number is 59.",
        requiredFormat: (value) =>
          value.toString().length === 2 || "Invalid Format.",
        // minRow: value => value >= 10 || "The minimum row is 10",
        // maxRow: value => value <= 15 || "The maximum row is 15.",
        // minColumn: value => value >= 4 || "The minimum row is 4.",
        // maxColumn: value => value <= 7 || "The maximum row is 7."
      },
      agentReservation: this.data.agent_reservation ? true : false,
      onlineStatus: this.data.online_status ? true : false,
      merchantStatus: this.data.merchant_status ? true : false,
      cardStatus: this.data.card_status ? true : false,
      cashStatus: this.data.cash_status ? true : false,
      addOnStatus: this.data.add_on_status ? true : false,
      subcompany_list: this.data.client_sub_companies
        ? this.data.client_sub_companies.length
          ? this.data.client_sub_companies
              .filter((item) => item.status === 1)
              .map((item) => {
                return item.client_id;
              })
          : []
        : [],
    };
  },
  methods: {
    async removeDenomination(denom) {
      this.data.denomination_list = await this.data.denomination_list.filter(
        (item) => item.value !== denom,
      );
    },
    async addDenomination() {
      let res = await this.data.denomination_list.filter(
        (item) => item.value == this.newDenomValue,
      );
      if (this.newDenomValue <= 10000) {
        if (res.length == 0) {
          if (this.newDenomValue && this.newDenomValue != 0) {
            let data = {
              value: this.newDenomValue,
              status: false,
            };
            this.data.denomination_list.push(data);

            this.data.denomination_list = await this.data.denomination_list.sort(
              (a, b) => a.value - b.value,
            );
            this.newDenomValue = null;
          } else {
            this.$infoBar({
              type: "error",
              text: "Invalid input!",
            });
          }
        } else {
          this.$infoBar({
            type: "error",
            text: "Denomination already exist!",
          });
        }
      } else {
        this.$infoBar({
          type: "error",
          text: "Maximum denomination is 10,000",
        });
      }
    },
    async removeCardReplacementPrice(cardRepPrice) {
      this.data.card_replacement_price_list = await this.data.card_replacement_price_list.filter
        (
          (item) => item.value !== cardRepPrice
        )
    },
    async addCardReplacementPrice() {
      let res = await this.data.card_replacement_price_list.filter(
        (item) => item.value == this.newCardRepPrice,
      );
      if (this.newCardRepPrice <= 10000){
        if (res.length == 0) {
          if (this.newCardRepPrice && this.newCardRepPrice != 0) {
            let data = {
              value: this.newCardRepPrice,
              status: false,
            };
            this.data.card_replacement_price_list.push(data);

            this.data.card_replacement_price_list = await this.data.card_replacement_price_list.sort(
              (a, b) => a.value - b.value,
            );
            this.newCardRepPrice = null;
          } else {
            this.$infoBar({
              type: "error",
              text: "Invalid input!",
            });
          }
        } else {
          this.$infoBar({
            type: "error",
            text: "Card Replacement Price already exist!",
          });
        }
      } else {
        this.$infoBar({
          type: "error",
          text: "Maximum Card Replacement Price is 10,000",
        });
      }
    },
    clear() {
      this.$refs.form.reset();
    },
    validateForm() {
      return this.$refs.form.validate();
    },
  },
};
</script>

<style scoped>
.scrolling-wrapper {
  overflow-x: hidden;
  height: 200px;
  overflow-y: scroll;
  white-space: nowrap;
}
.v-input__icon--append .v-icon {
  color: purple;
}
</style>
